import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "currencySign",
})
export class CurrencySignPipe implements PipeTransform {
  transform(value: string, currency: "iqd" | "dollar"): unknown {
    if (value != null) {
      if (currency === "iqd") return value + " د.ع ";
      else return " $ " + value;
    } else return value;
  }
}
